<template>
  <div v-show="saleDifferenceAlternativeSmall || saleDifferenceSmall">
    {{ saleDifferenceAlternativeSmall || saleDifferenceSmall }}
  </div>
</template>

<script>
import productPrice from 'theme/mixins/productPrice.ts'

export default {
  name: 'SpecialPriceTile',
  mixins: [productPrice]
}
</script>
